import React from 'react';
import './about.css';

// १. मजकूर/डेटा एका ऑब्जेक्टमध्ये (Data Object) ठेवणे
const aboutUsData = {
  title: " गट ग्रामपंचायत सोनेगाव : प्रगतीचा संकल्प",
  intro:
    " सोनेगाव कळमेश्वर तालुक्यात असलेले, संस्कृती आणि कृषीचे उत्तम मिश्रण असलेले गाव आहे. स्थानिक स्वराज्य संस्था म्हणून आम्ही,  सोनेगाव एक आदर्श, आत्मनिर्भर आणि तंत्रज्ञान-स्नेही गाव बनवण्यासाठी कटिबद्ध आहोत.",

  visionTitle: "💡 आमची दृष्टी (Our Vision)",
  vision: [
    {
      icon: "🌐",
      title: "डिजिटल ग्राम",
      description:
        "ग्रामपंचायतीचे कामकाज पारदर्शक (Transparent) आणि डिजिटल माध्यमांतून चालवणे.",
    },
    {
      icon: "🌿",
      title: "पर्यावरण पूरक विकास",
      description:
        "गावातील स्वच्छता, पाणी व्यवस्थापन आणि नैसर्गिक संसाधनांचे संरक्षण करणे.",
    },
    {
      icon: "🤝",
      title: "युवा आणि महिला सबलीकरण",
      description:
        "शिक्षण, आरोग्य आणि रोजगाराच्या संधी उपलब्ध करून तरुण आणि महिलांना सशक्त करणे.",
    },
  ],

  servicesTitle: "🏗 सेवा आणि सुविधा",
  services: [
    "पायाभूत सुविधा: उत्तम रस्ते, २४x७ पाणीपुरवठा आणि सार्वजनिक बांधकाम.",
    "दाखले आणि नोंदी: जन्म-मृत्यू, रहिवासी आणि विविध शासकीय दाखले वेळेत देणे.",
    "शासकीय योजना: केंद्र आणि राज्य सरकारच्या महत्त्वाकांक्षी योजनांचा लाभ थेट लाभार्थ्यांपर्यंत पोहोचवणे.",
  ],

  gramPanchayatInfo: {
    title: "📄 ग्रामपंचायतीची माहिती",
    details: [
      "ग्रामपंचायतीचे नाव :  सोनेगाव",
      "तालुका : कळमेश्वर",
      "जिल्हा : नागपूर",
      "स्थापना वर्ष : 1962",
      "ग्रामपंचायत नोंदणी क्रमांक : 770 / 1962",
      "मतदार संख्या : 964",
      "पुरुष मतदार संख्या: 2038",
      "महिला मतदार संख्या : ",
      "सदस्य संख्या : 11",
      "सरपंच : सौ. रुपाली हरीश पुनतकर",
      "उपसरपंच :सौ. गायत्री लालाजी आंबोले",
      "ग्रामसेवक : कविता सुरेश राऊत ",
      "कार्यालयीन पत्ता : गट ग्रामपंचायत सोनेगाव ",
      "कार्यालय संपर्क : 7972382206"
    ]
  },

  gavabadhal: {
    title: "🏡 गावाबद्दल माहिती",
    details: [
      "एकूण लोकसंख्या : 4114",
      "पुरुष लोकसंख्या : 2038",
      "महिला लोकसंख्या : 2076",
      "एकूण कुटुंब संख्या : 1124",
      "कर मागणी खातेदार सांख्य : 1676",
      "हातपंप संख्या : 23",
      "विहिर संख्या : 13+35",
      "तलाव / नदी : 4+2",
      "खांबांची संख्या : 241",
      "दिव्या ची संख्या: 211",
      "सार्वजनिक शौचालये : 02",
      "खाजगी शौचालये : 638",
      "C.C. रस्त्यांची लांबी : 800 मीटर",
      "वार्ड संख्या: 4",
      "बोअरवेल संख्या : 23",
      "जुनी पाणीपुरवठा योजना : 90,000 लिटर (2006-2008)",
      "नवीन पाणीपुरवठा योजना : 2,00,0000 लिटर (2020)",
    ],
  },

  // ✅ फोटोमधील माहिती – शिक्षण व्यवस्था
  education: {
    title: "📚 शिक्षण व्यवस्था",
    email: "gpsonegaon01.@gmail.com",
    content: [
      " सोनेगाव ग्रामपंचायत अंतर्गत जिल्हा परिषद शाळा कार्यरत आहे.",
      "गावामध्ये इयत्ता १ ली ते ७ वी पर्यंत शिक्षणाची सुविधा उपलब्ध आहे.",
      "विद्यार्थ्यांसाठी शालेय पोषण आहार, मोफत पाठ्यपुस्तके, गणवेश व शिष्यवृत्ती योजना राबविल्या जातात.",
      "शिक्षणाचा दर्जा उंचावण्यासाठी शाळा इमारत दुरुस्ती, वर्गखोल्या, स्वच्छतागृहे व पिण्याच्या पाण्याची व्यवस्था करण्यात आली आहे.",
      "विद्यार्थ्यांच्या सर्वांगीण विकासासाठी क्रीडा साहित्य व शैक्षणिक उपक्रमांना प्रोत्साहन दिले जाते.",
    ],
  },



  participation: {
    heading: "🤝 तुमचा सहभाग महत्त्वाचा",
    content:
      "ग्रामपंचायत म्हणजे केवळ कार्यालय नव्हे; ती गावकऱ्यांची संस्था आहे. आम्ही ग्रामसभेला सर्वाधिक महत्त्व देतो, कारण गावचा विकास हा केवळ प्रशासनाचा नाही, तर सामूहिक जबाबदारीचा विषय आहे.",
  },

  sarpanch: {
    name: "सौ. रुपाली हरीश पुनतकर",
    slogan: "👉 'प्रत्येक नागरिकाच्या आवाजाला महत्त्व'",
    message:
      "मी, सौ. रुपाली हरीश पुनतकर,  सोनेगाव नेतृत्वाची जबाबदारी स्वीकारताना हे सुनिश्चित केले आहे की, ग्रामपंचायतीचे दरवाजे प्रत्येक सामान्य नागरिकासाठी खुले असतील.",
    successTitle: "🎯 आमच्या कारभाराचे यशोगाथा",
    successStories: [
      {
        heading: "जबाबदार पाणी व्यवस्थापन",
        detail:
          "पाणी आडवा, पाणी जिरवा या तत्त्वावर काम करत जलसंधारणाची कामे पूर्ण केली.",
      },
      {
        heading: "प्रदूषण नियंत्रण",
        detail:
          "प्लास्टिक वापरावर निर्बंध व सार्वजनिक स्वच्छता मोहिमा राबविल्या.",
      },
      {
        heading: "सुलभ सेवा",
        detail:
          "दाखले जास्तीत जास्त ४८ तासांत देण्याची सुविधा सुरू केली.",
      },
    ],
    youthTitle: "🌱 गावातील तरुणांसाठी गुंतवणूक",
    youthInvestment: [
      {
        heading: "डिजिटल कौशल्ये",
        detail: "कॉम्प्युटर प्रशिक्षण व स्पर्धा परीक्षा मार्गदर्शन.",
      },
      {
        heading: "आरोग्य आणि खेळ",
        detail: "Open Gym व खेळाचे मैदान विकसित केले.",
      },
    ],
    closing:
      " सोनेगाव नागरिकांचे प्रेम आणि विश्वास हीच माझ्या कामाची खरी प्रेरणा आहे.",
  },
};

// Reusable Vision Component
const VisionItem = ({ icon, title, description }) => (
  <div className="vision-card">
    <div className="vision-icon">{icon}</div>
    <h4>{title}</h4>
    <p>{description}</p>
  </div>
);

// Main Component
const AboutUs = () => {
  const { sarpanch } = aboutUsData;

  return (
    <div className="page about-us-page">
      <header className="page-header">
        <h1>{aboutUsData.title}</h1>
        <p>{aboutUsData.intro}</p>
      </header>

      <main className="page-content-grid">
        {/* Vision */}
        <section className="section">
          <h2>{aboutUsData.visionTitle}</h2>
          <div className="vision-cards-container">
            {aboutUsData.vision.map((item, i) => (
              <VisionItem key={i} {...item} />
            ))}
          </div>
        </section>

        {/* Services */}
        <section className="section">
          <h2>{aboutUsData.servicesTitle}</h2>
          <ul>
            {aboutUsData.services.map((s, i) => (
              <li key={i}>{s}</li>
            ))}
          </ul>
        </section>

        <section className="section bg-light">
          <h2>{aboutUsData.gavabadhal.title}</h2>

          <div className="gav-info-grid">
            {aboutUsData.gavabadhal.details.map((info, index) => (
              <div key={index} className="gav-info-card">
                {info}
              </div>
            ))}
          </div>
        </section>

        {/* ✅ Education Section */}
        <section className="section bg-light">
          <h2>{aboutUsData.education.title}</h2>
          <p>
            <strong>ई-मेल :</strong>{" "}
            <a href={`mailto:${aboutUsData.education.email}`}>
              {aboutUsData.education.email}
            </a>
          </p>
          <ul>
            {aboutUsData.education.content.map((item, i) => (
              <li key={i}>{item}</li>
            ))}
          </ul>
        </section>

        {/* ✅ ग्रामपंचायतीची माहिती */}
        <section className="section">
          <h2>{aboutUsData.gramPanchayatInfo.title}</h2>

          <div className="gav-info-grid">
            {aboutUsData.gramPanchayatInfo.details.map((item, index) => (
              <div key={index} className="gav-info-card">
                {item}
              </div>
            ))}
          </div>
        </section>


        {/* Participation */}
        <section className="section">
          <h3>{aboutUsData.participation.heading}</h3>
          <p>{aboutUsData.participation.content}</p>
        </section>

        {/* Sarpanch */}
        <section className="section">
          <h2>सन्माननीय सरपंच : {sarpanch.name}</h2>
          <p>{sarpanch.slogan}</p>
          <p>{sarpanch.message}</p>
        </section>
      </main>

      <footer className="page-footer">
        <p>*** {sarpanch.closing} ***</p>
      </footer>
    </div>
  );
};

export default AboutUs;
